import Add from './add/CanAddOrganizationCountInitialState'

const { Record } = require('immutable');

export default Record({
    add: Add()
});